const spinner = {}
spinner.install = function (Vue, options) {
  const object = {
    show (message = options.language.capitalize(options.language.i18n, 'loading')) {
      window.mApp.blockPage({
        overlayColor: '#000000',
        type: 'loader',
        state: 'primary',
        message: message
      })
      window.$('.blockUI').css('left-margin', '50%')
    },
    remove () {
      window.mApp.unblockPage()
    }
  }
  Vue.prototype.$spinner = object
}

export default spinner



// WEBPACK FOOTER //
// app/javascript/src/plugins/spinner/spinnerBlock.js